import { FaTelegramPlane } from "react-icons/fa";
import { ArrowRight, Clock, Landmark, Zap } from "lucide-react";
import { Reveal, Stagger, Item } from "@/components/motion/Reveal";
import { Eyebrow } from "@/components/shared/Primitives";
import { LiveAlertFeed } from "@/components/home/LiveAlertFeed";

const HIGHLIGHTS = [
  { icon: Clock, value: "24/7", label: "Monitoring across every session and rollover." },
  { icon: Landmark, value: "Macro + markets", label: "Central banks, releases, geopolitics and risk." },
  { icon: Zap, value: "Instant delivery", label: "Pushed to Telegram the moment news breaks." },
];

export const TelegramAlerts = () => (
  <section className="section relative overflow-hidden" data-testid="telegram-alerts">
    <div className="absolute inset-0 -z-10 bg-[linear-gradient(135deg,#f3f0ff_0%,#e4ebfd_40%,#dbe6fb_70%,#eef2fa_100%)]" />
    <div className="absolute -top-20 left-[-8%] -z-10 h-[620px] w-[620px] rounded-full bg-[radial-gradient(circle,rgba(0,82,255,0.22)_0%,transparent_68%)]" />
    <div className="absolute -bottom-32 right-[-6%] -z-10 h-[560px] w-[560px] rounded-full bg-[radial-gradient(circle,rgba(139,92,246,0.20)_0%,transparent_70%)]" />

    <div className="container-x">
    <div
      className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8 items-stretch rounded-[28px] border border-white/80 bg-white/90 p-7 sm:p-10 lg:p-12 shadow-[0_30px_80px_-40px_rgba(10,15,29,0.28),0_1px_0_rgba(255,255,255,0.9)_inset] backdrop-blur-[12px]"
      data-testid="telegram-alerts-panel"
    >
      {/* Left — editorial content (unchanged) */}
      <div className="lg:col-span-4">
        <Reveal>
          <Eyebrow className="mb-4">News intelligence · Telegram</Eyebrow>
          <h2 className="t-h2 lg:text-[44px] xl:text-[50px]">24/7 High Alert<br />Market News</h2>
          <p className="mt-6 max-w-md t-lead">We don't just publish trade ideas. Stay ahead of fast-moving markets with instant Telegram alerts on major economic releases, policy shifts and market-moving events.</p>
          <a
            href="https://t.me/forexbrokersignals"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary mt-10"
            data-testid="telegram-alerts-cta"
          >
            <FaTelegramPlane size={16} /> Join the Telegram channel <ArrowRight size={16} />
          </a>
        </Reveal>
      </div>

      {/* Center — live alert feed */}
      <Reveal delay={0.12} className="lg:col-span-5 flex">
        <LiveAlertFeed />
      </Reveal>

      {/* Right — supporting highlights, matched height */}
      <Stagger className="lg:col-span-3 flex flex-col gap-4" gap={0.1} delay={0.2}>
        {HIGHLIGHTS.map((h) => (
          <Item key={h.value} className="flex flex-1">
            <div className="card card-plain group flex h-full w-full flex-col justify-center p-6 transition-colors duration-300 hover:border-[var(--line-2)]" data-testid={`telegram-highlight-${h.value.replace(/\W+/g, "-").toLowerCase()}`}>
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[var(--cobalt-soft)] text-[var(--cobalt)] transition-transform duration-300 group-hover:scale-105">
                <h.icon size={17} strokeWidth={1.75} />
              </span>
              <p className="t-h4 mt-5">{h.value}</p>
              <p className="mt-2 text-[13.5px] leading-[1.45] text-[var(--ink-3)]">{h.label}</p>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
    </div>
  </section>
);
